export const onlyLettersAndSpaces = '^[a-zA-ZáéíóúñÑ\\s]*$';
export const onlyNumbers = '^[0-9]*$';
